module.exports = __webpack_public_path__ + "img/leftbicep-ectomorph-male.73390f0c.svg";